import { showErrorFlag, showSuccessFlag } from './flags-helper';

export const deleteItem = async (apiService: any, item: any, flags: any, dialog: any) => {
  try {
    await apiService.hardDelete(item.uid);
    showSuccessFlag('Deleted', `${item.name} was successfully deleted.`, flags);
    dialog?.closeDialog();
  } catch (error) {
    showErrorFlag('Deletion failed', `Unable to delete ${item.name}, please try again.`, flags);
  }
};

export const deleteItems = async (apiService: any, items: any[], flags: any, dialog: any) => {
  try {
    await apiService.bulkHardDelete(items);
    showSuccessFlag('Deleted', `${items.length} items were successfully deleted.`, flags);
    dialog?.closeDialog();
  } catch (error) {
    showErrorFlag('Deletion failed', `Unable to delete ${items.length} items, please try again.`, flags);
  }
};
